import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import type { RequestAutomation } from '@app/src/types/automations'
import type { ExpectationAutomation } from '@app/src/types/expectations'
import { useCallback, useMemo } from 'react'
import { combineAutomations } from '../AutomationsConfigLogic'

export const useAutomations = () => {
  const {
    items: requestAutomations,
    refetch: refetchRequestAutomations,
    isLoading: isLoadingRequestAutomations,
  } = useFetchCollectionWithPost<RequestAutomation>({
    payload: {
      filter: [],
      include: ['templateAutomations.template'],
    },
    key: FetchKey.Automation,
    endpoint: endpoints.automations,
  })

  const {
    items: expectationAutomations,
    refetch: refetchExpectationAutomations,
    isLoading: isLoadingExpectationAutomations,
  } = useFetchCollectionWithPost<ExpectationAutomation>({
    payload: {
      filter: [],
      include: ['assessmentTemplate'],
    },
    key: FetchKey.ExpectationAutomation,
    endpoint: endpoints.expectationAutomationFilter,
  })

  const automations = useMemo(
    () => combineAutomations(requestAutomations ?? [], expectationAutomations ?? []),
    [requestAutomations, expectationAutomations],
  )

  const refetchAll = useCallback(async () => {
    await Promise.all([refetchRequestAutomations(), refetchExpectationAutomations()])
  }, [refetchRequestAutomations, refetchExpectationAutomations])

  return {
    automations,
    isLoading: isLoadingRequestAutomations || isLoadingExpectationAutomations,
    refetchAll,
  }
}
